<template>
  <Loader v-if="pending" />
  <Datamatrix
    v-else
    :encode-string="scanCode"
    :width="width"
    :height="height"
    no-tooltip
    class="datamatrix-hoverable"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Datamatrix from '@/components/dev/Datamatrix.vue';

export default {
  name: 'LabelArchiveMatrix',
  props: {
    labelArchiveId: {
      type: Number,
      default: 0,
    },
    width: {
      type: String,
      default: '45px',
    },
    height: {
      type: String,
      default: '45px',
    },
    noTooltip: Boolean,
  },
  data: () => ({
    labelArchiveDetails: null,
  }),
  components: { Datamatrix },
  computed: {
    ...mapGetters([
      'globalSettings',
    ]),
    scanCode() {
      return this.labelArchiveDetails?.scanCode || '';
    },
    pending() {
      return !this.labelArchiveDetails;
    },
  },
  watch: {
    labelArchiveId() {
      this.fetchLabelArchiveDetails();
    },
  },
  methods: {
    ...mapActions('labelArchive', [
      'getLabelArchiveByIds',
    ]),
    async fetchLabelArchiveDetails() {
      if (!this.labelArchiveId) return;

      const { data } = await this.getLabelArchiveByIds({
        params: {
          plantCode: this.globalSettings.plantCode,
          query: {
            ids: [this.labelArchiveId],
          },
        },
      });
      this.labelArchiveDetails = data[0] || null;
    },
  },
  mounted() {
    if (!this.labelArchiveId) return;
    this.fetchLabelArchiveDetails();
  },
};
</script>

<style scoped>
.datamatrix-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.datamatrix-hoverable {
  cursor: zoom-in;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(7) translate(30%, 40%);
    background-color: white;
    box-shadow: 0 0 50px 10px rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
}
</style>
